export const resourceConsolidation = (amount) => {
  let total = amount;

  const gold = Math.min(Math.floor(total / 10), 16);
  total -= gold * 10;
  const silver = Math.floor(total / 5);
  total -= silver * 5;
  const copper = total;

  return { gold, silver, copper };
};

export const getGridCoords = (value, min = 0) => {
  if (value === 0) {
    if (min < 0) {
      return {
        col: 1,
        row: 2,
      };
    }

    return {
      col: 1,
      row: 1,
    };
  }
  let row = 1;
  let col = (value % 5) + 1;
  if (col === 1) {
    col = 6;
  }

  if (min < 0) {
    row++;
  }
  if (value > 5) {
    row++;
  }
  if (value < 0) {
    row--;
    col = 7 + value;
  }
  if (value > 10) {
    const remainder = value % 10;
    if (remainder < 6) {
      row = min < 0 ? 2 : 1;
    } else {
      row = min < 0 ? 3 : 2;
    }
    if (remainder === 0) {
      row = min < 0 ? 3 : 2;
    }
  }

  return {
    col,
    row,
  };
};
